import type { ErrorComponentProps } from "@tanstack/react-router";

import ReloadIcon from "@/assets/icons/Iconex/Light/Restart.svg?react";
import { useTranslation } from "@/hooks/useTranslation";
import { reportAppError } from "@/utils/telemetry";
import { ExpandMore } from "@mui/icons-material";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	SvgIcon,
} from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";

function getErrorString(error: any) {
	let errorString = "Something went wrong";
	errorString = error.toString();
	//   if (error instanceof ApiError) {
	//     const detail = {
	//       status: error.status,
	//       body: error.body,
	//     };
	//     errorString = `${error.toString()}\n${JSON.stringify(detail)}`;
	//   } else if (error instanceof Error) {
	//     errorString = error.toString();
	//   }

	return errorString;
}

export const ErrorDisplay = ({
	error,
	info,
	children,
}: React.PropsWithChildren<{
	error: unknown;
	info?: ErrorComponentProps["info"];
}>) => {
	const { t } = useTranslation();
	const errorString = getErrorString(error);

	return (
		<Box
			sx={{
				width: "100%",
				height: "100%",
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "space-between",
				mb: 6,
			}}
		>
			<h2 data-testid="error-title">{t("error.unexpected")}</h2>
			{children}

			<Accordion sx={{ width: "100%" }}>
				<AccordionSummary expandIcon={<ExpandMore />}>
					{t("error.details")}
				</AccordionSummary>
				<AccordionDetails>
					<pre style={{ textWrap: "wrap" }}>{errorString}</pre>
					{info?.componentStack && <pre>Occured at: {info.componentStack}</pre>}
				</AccordionDetails>
			</Accordion>
		</Box>
	);
};

export const ErrorComponent = ({
	error,
	info,
	reset,
}: {
	error: Error;
	info?: ErrorComponentProps["info"];
	reset: CallableFunction;
}) => {
	const { t } = useTranslation();
	useEffect(() => {
		reportAppError(error, "boundary", info?.componentStack);
	}, [error, info?.componentStack]);
	return (
		<ErrorDisplay error={error} info={info}>
			<Box sx={{ display: "flex", gap: "1rem", pt: 2 }}>
				<Button onClick={() => reset()}>
					<SvgIcon sx={{ marginInlineEnd: 2 }}>
						<ReloadIcon />
					</SvgIcon>
					{t("error.tryAgain")}
				</Button>
			</Box>
		</ErrorDisplay>
	);
};
